import { Component, ElementRef, OnDestroy, OnInit, Optional } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, tap, take, switchMap } from 'rxjs/operators';
import { TaskHandler } from '../../TaskHandler';
import {
  TenderClassificationType,
  TenderLotClassificationDTO,
  TenderClassificationDTO
} from '../model/tenderClassification.model';
import * as lodash from 'lodash';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { HeaderActionsService } from '../../../components/common/sub-header/header-actions.service';
import { FunctionDef } from '../../../components/forms/form.objects';
import { Configuration } from '../../../conf/app.constants';
import { UIService, generateRandomIdentifier } from '../../../ui.service';
import { FieldConfig } from '../../../api/contract-notice-dto';
import { TriStateDTO, ProcedureDTO, TenderAdmissionStatusCodeDTO, getParentIdentifierFromString, getSimpleIdentifierFromString } from '../../../api/plyca-dtos';
import { HttpClient } from '@angular/common/http';
import { ResultTypeDTO, ValidationResultDTO, ValidationResultDTOError } from '../../../api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { HelpService, HelpType } from '../../../components/common/help/help.service';


@Component({
  selector: 'tenderClassification',
  templateUrl: 'tenderClassification.template.html',
  providers: [DialogService, UIService],
  /*styles: [
    `
    p-inputnumber.pruebaXXX input {
    background-color: yellow;
    }
    `
  ]*/
})
export class TenderClassificationComponent extends TaskHandler implements OnInit, OnDestroy {

  public windowHash: string;
  public tenderClassification: TenderClassificationDTO;
  private paramProject: ProcedureDTO;
  private paramTenderClassificationType: TenderClassificationType;

  public TriStateDTO = TriStateDTO;
  /**
   * Objeto utilizado formelement del campo de busqueda de unidades organicas
   * ya que necesita una propiedad/json path sobre un objeto para hacer binding
   */
  // variables de la tabla
  // public tenderLotClassificationsTableRowModel: TenderLotClassificationDTO[];
  public tenderLotClassificationsMapTableRowModel: Map<number, Array<TenderLotClassificationDTO>>

  load: boolean;
  tagsParent: string[];
  isModal: boolean;

  public functions: Array<FunctionDef>;

  constructor(private headerActionsService: HeaderActionsService,
    @Optional() protected dialogRef: DynamicDialogRef,
    @Optional() protected dialogConfig: DynamicDialogConfig,
    private configuration: Configuration,
    private elem: ElementRef,
    private helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler,
    private translate: TranslateService) {
    super();

    if (this.dialogConfig) {

      if (this.dialogConfig['action']) { // Se abre la pantalla mediante una action desde la gestión de expedientes en AYMA
        this.isModal = true;
        this.windowHash = generateRandomIdentifier();
        /*
        config['action'] = action;
        config['paramsDef'] = action.definition.parametersDefinition;
        config['dto'] = dto;*/
        this.paramProject = this.dialogConfig['dto'];
      } else if (this.dialogConfig.data) {
        // OFERTAS
        this.isModal = true;
        this.windowHash = generateRandomIdentifier();
        this.paramProject = this.dialogConfig.data.project;
        this.paramTenderClassificationType = this.dialogConfig.data.tenderClassificationType;
      } else {
        // Pasa es tarea por aqui!!, No generamos el windowHash!!
      }
    }
    this.functions = [];
  }

  ngOnInit(): void {
    if (this.isModal) {
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap(
          (storedHelpTags) => {
            this.tagsParent = storedHelpTags;
            return this.helpService.showContextHelpObservable(HelpType.CONSULT_TENDERCLASSIFICATION)
          }
        )));
    }
    this.subscribe(this.loadTenderClassificationTableObservable().pipe(
      tap(() => {
        /*


                let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);
                let val: TenderClassificationType[] = Object.values(TenderClassificationType);
                let dd: TenderClassificationType = TenderClassificationType[tenderClassificationType as keyof typeof TenderClassificationType];
                let reult = val.includes(dd);

                let tenderClassificationType2 = 'CLASIFI';
                let dd22: TenderClassificationType = TenderClassificationType[tenderClassificationType2 as keyof typeof TenderClassificationType];
                let reult22 = val.includes(dd22);

                if (dd === TenderClassificationType.CLASIFICAR) {
                  console.log('Modo clasificar');
                }
                if (tenderClassificationType === TenderClassificationType.CLASIFICAR) {
                  console.log('Modo clasificar');
                }*/
        let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);
        let dossier = getParentIdentifierFromString(this.tenderClassification.identifier);
        this.initHeaderActions();
      }),
      finalize(() => this.load = true)
    ));
  }

  /* public getTenderClassificationTypeFromString(input: string): TenderClassificationType | undefined {
     const upperCaseInput = input.toUpperCase();

     // Verificar si la cadena coincide con alguna clave del enum
     if (Object.values(TenderClassificationType).includes(upperCaseInput)) {
       // Convertir la cadena a la clave del enum y devolver el valor correspondiente
       return TenderClassificationType[upperCaseInput as keyof typeof TenderClassificationType];
     } else {
       return undefined; // La cadena no coincide con ninguna clave del enum
     }
   }*/

  ngOnDestroy(): void {
    this.dialogRef = null;
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        super.ngOnDestroy();
      })));

    super.ngOnDestroy();
  }

  /*public validate<T extends IObjectDTO<any>>(
    serviceUrl: string,
    validation: string,
    object: T
  ): Observable<ValidationResultDTO> {
    let url =
      this._configuration.URL_BASE + serviceUrl + 'validations/' + validation;
    return this._http
      .put<ValidationResultDTO>(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }*/

  /*private cleanHistory(usuid: string): Observable<any> {
    // TODO revisar plycaService simpleUpdate
    this.waitService.startWaiting();
    let url = this.configuration.URL_BASE + this.configuration.ADMIN_USER_SERVICE_URL + 'cleanHistory?user=' + usuid;
    return this._http.put(url, {}, { observe: 'response' }).pipe(
      catchError((error: any) => {

        return throwError(error);

      }),
      finalize(() => this.waitService.cancelWaiting())
    );
  }*/

  /*public update<T extends IObjectDTO<any>>(
    serviceUrl: string,
    object: T,
    context?: string
  ): Observable<any> {
    let url =
      this._configuration.URL_BASE +
      (serviceUrl.endsWith('/') ? serviceUrl : serviceUrl + '/') +
      getSimpleIdentifierFromString(object.identifier);
    if (context) {
      if (object.context == null)
        object.context = new ObjectContextDTO();

      object.context.name = context;
    }
    return this._http
      .put(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }*/

  // .update<ValidationResultDTO>(url, JSON.stringify(tenderClassification, (k, v) => (k === '_parent' ? undefined : v)))
  private tenderClassificationValidate(tenderClassification: TenderClassificationDTO): Observable<any> {
    let url = this.configuration.TENDERCLASSIFICATION_URL.replace('{dossierId}', this.getDossierId()) + 'validateTenderClassification';
    return this.plycaService
      .simpleUpdate(url, tenderClassification);
    /* .pipe(catchError((error: any)=> {
       this.errorHandler.showServerError(error);
     }
     ));*/
    /*.pipe(catchError(error => {
      //return throwError(error);
      this.handleError(error);
    }),
      finalize(() => this.waitService.cancelWaiting())
    );*/
  }

  public validate(): void {
    // this.displayDeleteHistory = false;
    if (this.task) {

      /*this.subscribe(
        this.tenderClassificationValidate(this.tenderClassification), () => {
          this.waitService.cancelWaiting();
          this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
            'success');

        },
        (error: any) => {
          this.waitService.cancelWaiting();
          this.uiService.showSuccess(this.translate.instant('General.errorMessage'), this.translate.instant('General.info'),
            'error');
          this.plycaErrorHandler.showServerError(error);

        });*/

      this.tenderClassificationValidate(this.tenderClassification).pipe(
        take(1)
      ).subscribe((tenderClassification: TenderClassificationDTO) => {
        let validation: ValidationResultDTO = tenderClassification.validationResult;
        if (validation?.result == ResultTypeDTO.OK) {
          const ref = this.uiService.showMessage(
            'El resultado de la validación es correcta',
            this.translate.instant('General.info'),
            'success'
          );
          ref.onClose.pipe(take(1)).subscribe(() => {
            this.loadAssignmentTable(tenderClassification);
          });
        } else {
          this.errorHandler.showServerError(validation);
        }
        // this.envelopeValidations.set(envelope.identifier, validation);
      },/* (error: any) => {
        if (this.formService.isValidationResponse(error)) {
          let validation = error as ValidationResultDTO;
          // this.envelopeValidations.set(envelope.identifier, validation);
        } else {
          //console.error('error al validar sobre con id' + envelope.identifier, error);
          //this.envelopeValidations.delete(envelope.identifier);
        }*/
        (error: any) => {
          this.errorHandler.showServerError(error);
        });

      /*// asociar a tarea cambios sobre el clonado del work hecho en el interface
      this.task.work.tenderClassification = this.tenderClassification;


      let url = this.configuration.TENDERCLASSIFICATION_URL.replace('{dossierId}', this.getDossierId()) + 'validateTenderClassification';

      this.waitService.startWaiting();
      return this._http.put(url, {}, { observe: 'response' }).pipe(
        catchError((error: any) => {

          return throwError(error);

        }),
        finalize(() => this.waitService.cancelWaiting())
      );*/

      /*this.plycaService.validate(url, 'UpdateFLIC', this.tenderClassification).pipe(
        take(1)
      ).subscribe((validation: ValidationResultDTO) => {
        this.envelopeValidations.set(envelope.identifier, validation);
      }, (error: any) => {
        if (this.formService.isValidationResponse(error)) {
          let validation = error as ValidationResultDTO;
          this.envelopeValidations.set(envelope.identifier, validation);
        } else {
          console.error('error al validar sobre con id' + envelope.identifier, error);
          this.envelopeValidations.delete(envelope.identifier);
        }
      });*/
    }
    /* private valdateEnvelope(envelope: EnvelopeDTO) {
       this.plycaService.validate(this.configuration.ENVELOPE_SERVICE_URL, 'UpdateFLIC', envelope).pipe(
         take(1)
       ).subscribe((validation: ValidationResultDTO) => {
         this.envelopeValidations.set(envelope.identifier, validation);
       }, (error: any) => {
         if (this.formService.isValidationResponse(error)) {
           let validation = error as ValidationResultDTO;
           this.envelopeValidations.set(envelope.identifier, validation);
         } else {
           console.error('error al validar sobre con id' + envelope.identifier, error);
           this.envelopeValidations.delete(envelope.identifier);
         }
       });
     }


   }*/
  }

  public save(): void {

    // this.displayDeleteHistory = false;
    if (this.task) {
      /*
      // *********   Establecer opción reasignación marcada bien por: *******************************************************************
      //    - Selección del usuario en caso de ser visible el panel de opciones
      //    - Valor por defecto que se  carga en función de la variable de contexto, this.context.manageCurrentProcedure, proporcionada
      //      por el servicio y cargada en el método loadAssignmentTable de esta clase.
      this.assignment.reassignActionType = this.reassignActionType;
      // ********************************************************************************************************************************
    */



      /*let modifiedAssignments = [] as ProfileAssignmentDTO[];
      // coger solo perfiles editables
      this.profiles.forEach((profile: ProfileTableRowModel) => {
        this.addIfAssignmentEditable(profile, modifiedAssignments);
      });
      this.assignment.listProfileAssignments = modifiedAssignments;
      // mantener / despachar
      this.processTask();
    } else {
      let modifiedAssignments = [] as ProfileAssignmentDTO[];
      if (this.reassignByProfiles) {
        // coger solo perfiles checkeados
        this.profiles.forEach((profile: ProfileTableRowModel) => {
          this.addIfProfileChecked(profile, modifiedAssignments);
        });
      } else {
        // coger solo perfiles modificados
        this.profiles.forEach((profile: ProfileTableRowModel) => {
          this.addIfAssignmentEditable(profile, modifiedAssignments);
        });
      }*/


      // asociar a tarea cambios sobre el clonado del work hecho en el interface
      this.task.work.tenderClassification = this.tenderClassification;
      // mantener / despachar
      this.processTask();
    }
  }

  private saveInternal(updatedTenderClassification: TenderClassificationDTO): void {
    let url = this.configuration.TENDERCLASSIFICATION_URL.replace('{dossierId}', this.getDossierId()) + 'updateTenderClassification';
    this.subscribe(this.plycaService.update<TenderClassificationDTO>(url, updatedTenderClassification),
      (result: any) => {
        console.log('Clasificación realizada');
        this.uiService.showMessage(this.translateService.instant('TenderClassification.successMsg'),
          this.translateService.instant('General.info'));
        // this.dialogRef.close({ saved: true });
      },
      (error: any) => {
        this.errorHandler.showServerError(error);
      }
    );
  }


  /* private loadAssignmentsTable() {
     this.subscribe(this.loadAssignmentsTableObservable());
   }*/

  private loadTenderClassificationTableObservable(): Observable<any> {
    // {{userAPI}}/dossiers/20190018000017/tenderClassifications/load/CLASIFICAR
    let tenderClassificationObs: Observable<TenderClassificationDTO>;
    if (this.task) {
      // acceso tarea
      // TODO ¿Es necesario?**********************************************************************************
      tenderClassificationObs = of(lodash.cloneDeep(this.task.work.tenderClassification));
      /*this.context = this.task.work.context.configurations;
      this.procedure = this.task.procedure;*/
    } /*else if (this.procedure) {
      // apertura desde  gestion de tramites
      const params = {
        procedureId: this.procedure.identifier
      };
      let url = this.configuration.LOAD_TASKASSIGNMENT_URL.replace('{dossierId}', this.getDossierId());
      this.waitService.startWaiting();
      assignmentObs = this.plycaService.get<TaskAssignmentDTO>(url,
        'CARGA_VARIABLES',
        params);
      }*/ else {
      // apertura desde  gestion de tramites
      // const params = {
      //   dossierId: this.getDossierId()
      // };

      if (this.paramTenderClassificationType === undefined) {
        this.paramTenderClassificationType = TenderClassificationType.CONSULTAR;
      }
      // identifier: "CLASIFICAR<>20190018000017"
      // let identifier = this.paramTenderClassificationType + '<>' + this.getDossierId();

      let url = this.configuration.LOAD_TENDERCLASSIFICATION_URL.replace('{dossierId}', this.getDossierId());
      this.waitService.startWaiting();
      tenderClassificationObs = this.plycaService.get<TenderClassificationDTO>(url, this.paramTenderClassificationType);
    }
    return tenderClassificationObs.pipe(
      tap((tenderClassification: TenderClassificationDTO) => {
        if (tenderClassification?.validationResult?.result !== ResultTypeDTO.OK) {
          // this.manageActionError(new ValidationResultDTOError(tenderClassification.validationResult), false);
          // this.errorHandler.showServerError(tenderClassification?.validationResult?.result);

          this.errorHandler.showServerError(new ValidationResultDTOError(tenderClassification.validationResult));
        }
        this.loadAssignmentTable(tenderClassification);
      }),
      catchError((error: any) => {
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      }),
      finalize(() => this.waitService.cancelWaiting())
    );
  }

  private initHeaderActions(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);

    let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);

    if (this.task) {
      // DESEMPATAR
      if (TenderClassificationType.DESEMPATAR === tenderClassificationType) {
        this.subscribe(this.headerActionsService
          .addWindowAction(
            'General.validate',
            'fas fa-check',
            'btn-primary',
            true,
            this.windowHash
          ),
          () => {
            /*if (this.canShowSaveOptions()) {
              if (this.isVisiblePanelOptions()) {
                this.displaySaveOptions = true;
              } else {
                this.saveOptions();
              }
            }*/
            this.validate();
          }
        );
        this.headerActionsService.addWindowDivider(this.windowHash);
      }
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'General.accept',
          'fas fa-lg fa-chec',
          'btn-primary',
          true,
          this.windowHash
        ),
        () => {
          /*if (this.canShowSaveOptions()) {
            if (this.isVisiblePanelOptions()) {
              this.displaySaveOptions = true;
            } else {
              this.saveOptions();
            }
          }*/
          if (this.task) {
            this.save();
          } else {
            this.dialogRef.close({ saved: false });
          }
        }
      );
      this.headerActionsService.addWindowDivider(this.windowHash);
    }

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'Salir',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      success => {
        if (this.task) {
          this.salir();
        } else {
          this.dialogRef.close({ saved: false });
        }
      });
  }


  public getDossierId(): string {
    // 1 apertura tarea
    let dossierId = (this.task) ? this.task.division.project.identifier : '';

    // 3 apertura en modal (reco)
    if (!dossierId && this.paramProject.division) {
      dossierId = this.paramProject.division.project.identifier;
    }
    // 2 apertura en modal
    // (contratacion)
    // Desde Ofertas
    if (!dossierId) {
      dossierId = (this.paramProject) ? this.paramProject.identifier : '';
    }
    /*
     3 apertura en modal (reco)
    if (!dossierId && this.dialogConfig.data.project.division) {
      dossierId = this.dialogConfig.data.project.division.project.identifier;
    }
    // 4 apertura en modal (contratacion)
    if (!dossierId) {
      dossierId = this.dialogConfig.data.project.identifier;
    }*/

    return dossierId;
  }

  private loadAssignmentTable(tenderClassification: TenderClassificationDTO, initLoad = true) {
    this.tenderClassification = tenderClassification;
    // this.tenderLotClassificationsTableRowModel = this.assignmentDataToTableModel(this.tenderClassification.sortedTenderLotClassifications);
    this.tenderLotClassificationsMapTableRowModel = this.assignmentDataMapToTableModel(this.tenderClassification.sortedTenderLotClassificationsMap);
  }

  private assignmentDataMapToTableModel(mapTenderLotClassifications: Map<number, Array<TenderLotClassificationDTO>>): Map<number, Array<TenderLotClassificationDTO>> {

    let listTenderLotClassifications: Array<any> = [];
    /*mapTenderLotClassifications.forEach((value: any, key: string) => {
      listTenderLotClassifications.push(value);
    }
    );

    listTenderLotClassifications = Array.from(mapTenderLotClassifications.values());*/

    /*
    <li *ngFor="let recipient of map | keyvalue">
        {{recipient.key}} --> {{recipient.value}}
    </li>*/

    return mapTenderLotClassifications;

  }


  private assignmentDataToTableModel(listTenderLotClassifications: TenderLotClassificationDTO[]): TenderLotClassificationDTO[] {
    /*let profilesMap = new Map<string, ProfileTableRowModel>();
    if (listProfileAssignments) {
      listProfileAssignments.forEach((profileAssignment: ProfileAssignmentDTO) => {
        const assignmentProfile = profileAssignment.profile.identifier;
        let rowModel = profilesMap.get(assignmentProfile);
        if (!rowModel) {
          rowModel = new ProfileTableRowModel();
          profilesMap.set(assignmentProfile, rowModel);
        }
        this.addProfileAssignmentToModel(profileAssignment, rowModel);
      });
    }
    let model = [];
    profilesMap.forEach((value: ProfileTableRowModel) => model.push(value));*/



    // private Boolean tiePosition; //posicionEmpate; //Posición empatada con otras
    return listTenderLotClassifications;
  }

  /*calculateTotal(lotNumber) { //tenderLotClassificationsTableRowModel.procurementProjectLot.lotNumber
    let total = 0;
    if (this.tenderLotClassificationsTableRowModel) {
      for (let tenderLotClassificationTableRowModel of this.tenderLotClassificationsTableRowModel) {
        if (tenderLotClassificationTableRowModel.procurementProjectLot.lotNumber === lotNumber) {
          total++;
        }
      }
    }
    return total;
  }*/

  debugRecorremosMap2(datas) { // tenderLotClassificationsTableRowModel.procurementProjectLot.lotNumber
    /*let total = 0;
    if (this.tenderLotClassificationsTableRowModel) {
      for (let tenderLotClassificationTableRowModel of this.tenderLotClassificationsTableRowModel) {
        if (tenderLotClassificationTableRowModel.procurementProjectLot.lotNumber === lotNumber) {
          total++;
        }
      }
    }*/
    // console.log('Reasignacion debugRecorremosMap2: ' + datas);
    return datas;
  }

  public getFieldConfig(): any {
    /*let config = new FieldConfig();
    config.fieldStyle = 'col-12';
    config.jsonField = name;
    if (name === this.FROM_PARAM) {
      config.type = 'DATETIME';
      config.description = 'Fecha desde:';
    } else if (name === this.TO_PARAM) {
      config.type = 'DATETIME';
      config.description = 'Fecha hasta:';
    } else if (name === this.USER_PARAM) {
      config.type = 'SEARCH';
      config.description = 'Usuario';
      config.idBuscador =
        'com.nexusit.framework.buscador.interfaz.BuscadorUsuarios';
      config.autoSearch = false;
    }*/


    /*let config = {
      "_descriptionKey": "Contracts.lots.title",
      "jsonField": "tenderLot.tenderEvaluation.classificationPosition",
      "type": "INTEGER",
      "_fieldStyle": "",
      "_colVisibility": "this.model.ui.apportioned",
      "_columnStyle": {
        "width": "30%"
      },
      "_editable": "this.model.ui && this.model.ui.isAutomaticMode? false : true"
    };*/
    let config2 = new FieldConfig();
    let config = {
      "_descriptionKey": "TenderEvaluationCommittee.edit.min_quorum",
      "_tooltipText": "Número mínimo de miembros de la mesa necesarios para la apertura",
      "jsonField": "tenderLot.tenderEvaluation.classificationPosition",
      "type": "INTEGER",
      "_required": true,
      "editable": true,
      "fieldStyle": "col-12",
      "_styleClass": "color:red"
    }
    return config;
  }
  public isDesempatar(): boolean {
    let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);
    if (TenderClassificationType.DESEMPATAR === tenderClassificationType) {
      return true;
    }
    return false
  }

  public isEditablePosicion(data: TenderLotClassificationDTO): boolean {
    let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);
    if (TenderClassificationType.DESEMPATAR != tenderClassificationType || (data.tenderLot.tenderEvaluation.tiebreakPosition === undefined
      && !data.tenderLotClassificationDataDisplay.tiebreak)) {
      return false;
    }
    return true;// ofertaLote.getLoteOferta().getPosicionDesempatar() == null && !ofer
  }

  public isVisiblePropuestaAdj(): boolean {
    let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);
    if (TenderClassificationType.CONSULTAR === tenderClassificationType || TenderClassificationType.PROPUESTA_ADJUDICACION === tenderClassificationType) {
      return true;
    }
    return false
  }

  public isEditablePropuestaAdj(data: TenderLotClassificationDTO): boolean {
    let tenderClassificationType: string = getSimpleIdentifierFromString(this.tenderClassification.identifier);
    if (TenderClassificationType.PROPUESTA_ADJUDICACION === tenderClassificationType && data.tenderLot.tenderEvaluation.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.ACEPTED) {
      return false;
    }
    return true;
  }
  /*
    ADMITIDA(0),
    RECHAZADA(3),
    EXCLUIDA(1);

    ACEPTED = 'ACEPTED',
    REFUSED = 'REFUSED',
    EXCLUDED = 'EXCLUDED'*/

  public getDescripctionStatusCode(statusCode: TenderAdmissionStatusCodeDTO): string {
    let description = 'SIN_DEFINIR';
    if (statusCode === TenderAdmissionStatusCodeDTO.ACEPTED
      || statusCode === TenderAdmissionStatusCodeDTO.EXCLUDED
      || statusCode === TenderAdmissionStatusCodeDTO.REFUSED
      || statusCode === TenderAdmissionStatusCodeDTO.INITIAL) {
      description = this.translateService.instant('TenderLotState' + statusCode);
    }
    return description
  }

  selectAwardProposal(evt: any, data: TenderLotClassificationDTO) {

    // let e = evt.value;
    let lotNumber = data.procurementProjectLot.lotNumber;
    let lotId = data.procurementProjectLot.lotId;
    let tenderLotIdentifier = data.tenderLot.identifier;
    let taxIdentifier = data.tender.tendererParty.company?.taxIdentifier;
    let tenderOrderNumber = data.tender.orderNumber;
    let awardProposal = data.tenderLot.tenderEvaluation.awardProposal;
    let recordedAwardProposal = data.tenderLotClassificationDataDisplay.recordedAwardProposal;


    // tenderLotClassificationsMapTableRowModel: Map<number, Array<TenderLotClassificationDTO>>

    // No funciona porque no lo considera una Map!!
    // let tenderLotClassifications: Array<TenderLotClassificationDTO> = this.tenderLotClassificationsMapTableRowModel.get(lotNumber);
    let tenderLotClassifications: Array<TenderLotClassificationDTO> = this.tenderLotClassificationsMapTableRowModel[lotNumber];

    let val = false

    let tenderLotClassificationProposals: TenderLotClassificationDTO[] = tenderLotClassifications.filter(
      (item) => {
        let result = false;
        if (tenderOrderNumber != item.tender.orderNumber) {
          result = (item.tenderLotClassificationDataDisplay.recordedAwardProposal === false && item.tenderLot.tenderEvaluation.awardProposal);
        } else {
          if (!awardProposal // ha deseleccionado la actual,
            && item.tenderLotClassificationDataDisplay.recordedAwardProposal === false) {
            result = true;
          }
        }
        return result;
      }
    );

    /*if (tenderLotClassificationProposals.length > 0) {
      let message = '¿Está seguro de cambiar la propuesta de adjudicación sugerida ?';
      this.uiService.showMessage(this.translateService.instant(message))
        .onClose.pipe(take(1)).subscribe(() => {
          if (awardProposal) {
            tenderLotClassifications.forEach((tenderLotClassification) => {
              if (tenderLotClassification.tender.orderNumber != tenderOrderNumber) {
                tenderLotClassification.tenderLot.tenderEvaluation.awardProposal = false;
              }
            });
          }
        });;

    }*/

    if (tenderLotClassificationProposals.length > 0) {
      let message = '¿Está seguro de cambiar la propuesta de adjudicación sugerida ?';
      this.confirmationService.confirm({
        message: message,
        acceptLabel: this.translateService.instant('General.yes'),
        rejectLabel: this.translateService.instant('General.no'),
        accept: () => {
          this.setAwardProposalFALSE(awardProposal, tenderLotClassifications, tenderOrderNumber);
        },
        reject: () => {
          data.tenderLot.tenderEvaluation.awardProposal = !awardProposal;
        }
      });
    } else {
      this.setAwardProposalFALSE(awardProposal, tenderLotClassifications, tenderOrderNumber);
    }
  }



  private setAwardProposalFALSE(awardProposal: boolean, tenderLotClassifications: TenderLotClassificationDTO[], tenderOrderNumber: number) {
    if (awardProposal) {
      tenderLotClassifications.forEach((tenderLotClassification) => {
        if (tenderLotClassification.tender.orderNumber != tenderOrderNumber) {
          tenderLotClassification.tenderLot.tenderEvaluation.awardProposal = false;
        }
      });
    }
  }
  /*this.confirmationService.confirm({
    message: this.translateService.instant('TaskAssignment.undoMsg'),
    acceptLabel: this.translateService.instant('General.yes'),
    rejectLabel: this.translateService.instant('General.no'),
    accept: () => {
      this.loadAssignmentsTable();
    }
  });*/

  /* let tenderLotClassificationProposal = tenderLotClassificationProposals[0];

   if (tenderLotClassificationProposals[0]
     && tenderOrderNumber != tenderLotClassificationProposal.tender.orderNumber) {
     let message = '¿Está seguro de cambiar la propuesta de adjudicación sugerida ?';
     this.uiService.showMessage(this.translateService.instant(message));
   }*/
  /*if (awardProposal) {
    tenderLotClassifications.forEach((tenderLotClassification) => {
      if (tenderLotClassification.tender.orderNumber != tenderOrderNumber) {
        tenderLotClassification.tenderLot.tenderEvaluation.awardProposal = false;
      }
    });*/
  // }


  // MSG_CAMBIO_PROPUESTA_ADJ=\u00bfEst\u00e1 seguro de cambiar la propuesta de adjudicaci\u00f3n sugerida?

  /*

  List<OfertaLote> listOfertaLoteSugerida= datos.stream()
  .filter(of -> !of.isPropuestAdjDatoBBDD())
  .collect(Collectors.toList());

  OfertaLote loteOfertaSugerida = null;
  if(listOfertaLoteSugerida != null && listOfertaLoteSugerida.size() == 1){
    loteOfertaSugerida = listOfertaLoteSugerida.get(0);
  }

  boolean validar = false;
  if(loteOfertaSugerida != null){
    if(ofertaLotePreSelected==ofertaLoteEditada && loteOfertaSugerida == ofertaLoteEditada){
      if(ofertaLotePreSelected.getLoteOferta().getPropuestaAdjudicacion()){
        validar = true;
      }
    }else{
      if(loteOfertaSugerida.getLoteOferta().getPropuestaAdjudicacion()){
        validar = true;
      }

    }
    if(validar){
      int res = JOptionPane.showConfirmDialog(null,controlTextos.getString("MSG_CAMBIO_PROPUESTA_ADJ"), controlTextos.getString("TITULO_MENSAJE_ADVERTENCIA"), JOptionPane.YES_NO_OPTION, JOptionPane.WARNING_MESSAGE);
          if (res == JOptionPane.NO_OPTION) {
            this.cancelCellEditing();
            return false;
          }
    }
  }*/

}